__webpack_require__.p = "https://admin.livestreammates.com/";